import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule, TgSvgModule } from '@trademe/tangram';
import { MotorsIllustrationBoatModule } from '../../components/motors-illustration-boat/motors-illustration-boat.module';
import { MotorsListingDetailsFieldSectionComponent } from './motors-listing-details-field-section.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgSvgModule,
        MotorsIllustrationBoatModule
    ],
    declarations: [MotorsListingDetailsFieldSectionComponent],
    exports: [MotorsListingDetailsFieldSectionComponent]
})
export class MotorsListingDetailsFieldSectionModule {}
